import { t } from "ttag";

import { HealthieForm } from "@/features/intake-form/components";
import { RefillRequestSuccessScreenAlert } from "@/features/my-meds/sections";
import type { Product } from "@/features/products/models";
import { useBoolean } from "@/shared/hooks";
import { Button } from "@/shared/ui";

interface RefillHealthieFormProps {
  productId: Product["id"];
  onCancel: () => void;
}
export const RefillHealthieForm = ({
  productId,
  onCancel,
}: RefillHealthieFormProps) => {
  const { value: showSuccessAlert, setTrue: openSuccessAlert } =
    useBoolean(false);

  return (
    <>
      <HealthieForm
        onSubmit={openSuccessAlert}
        params={{
          isAsync: true,
          isRefill: true,
          withRefill: true,
          productId,
        }}
      >
        <div className="flex flex-col-reverse items-stretch justify-between gap-4 md:flex-row md:items-center">
          <Button onClick={onCancel} variant="secondary" size="lg">
            {t`Back`}
          </Button>
          <Button type="submit" size="lg">
            {t`Next`}
          </Button>
        </div>
      </HealthieForm>

      <RefillRequestSuccessScreenAlert open={showSuccessAlert} />
    </>
  );
};
